import { PassportLogoutUrlRequest, PassportOAuthUrlRequest } from '@btsd/proto-generated-ts/auth';
import { AuthServiceClient } from '@btsd/proto-generated-ts/auth.client';
import { GrpcWebTransport } from '@/api/transport.ts';

export class AuthService {
  private authClient = new AuthServiceClient(GrpcWebTransport);

  public async getPassportLoginURL(
    installationId?: string,
    clientId?: string,
    otpConfirmation?: string,
  ): Promise<string> {
    const passportOAuthUrlRequest = {
      url: window.location.origin,
      installationId: installationId || '',
      customClientId: clientId || '',
      otpConformation: otpConfirmation || '',
    } as PassportOAuthUrlRequest;

    const { response } = await this.authClient.getPassportOAuthUrl(passportOAuthUrlRequest);

    return response.oauthUrl;
  }

  public async getPassportLogoutURL(): Promise<string> {
    const passportLogoutUrlRequest = {
      url: window.location.origin
    } as PassportLogoutUrlRequest;

    const passportOAuthUrlResponse = await this.authClient.getPassportLogoutUrl(
      passportLogoutUrlRequest,
    );

    return passportOAuthUrlResponse.response.logoutUrl;
  }

}

export const authService = new AuthService();